import { ModuleFE_AdvisorBoard } from '../../../_enum.js';
import { CollapsedPanelHeight, ColumnKey_LeftColumn, ColumnKey_MiddleColumn, ColumnKey_RightColumn, LeftColumn_AllClosed, MiddleColumn_Findings, PanelKey_AddProtocolData, PanelKey_Findings, PanelKey_HPI, PanelKey_Inbox, PanelKey_NextSteps, PanelKey_Settings, PanelKey_SmartDocs, PanelKey_Spotlight, RightColumnNew_Base } from '@app/advisor-v5-shared';
export const makeItDance = () => {
    ModuleFE_AdvisorBoard.resetAdvisorBoard();
    danceFunctions.forEach((func, index) => {
        setTimeout(() => func(), 700 * (index + 1));
    });
};
const danceFunctions = [
    () => {
        ModuleFE_AdvisorBoard.setColumnItems(ColumnKey_LeftColumn, [
            { panelKey: PanelKey_Inbox, height: 0.5 },
            { panelKey: PanelKey_HPI, height: 0.5 },
            { panelKey: PanelKey_SmartDocs, height: 0 },
        ]);
        ModuleFE_AdvisorBoard.setColumnItems(ColumnKey_MiddleColumn, [
            { panelKey: PanelKey_Spotlight, height: 0 },
            { panelKey: PanelKey_Findings, height: 1 },
        ]);
        ModuleFE_AdvisorBoard.setColumnItems(ColumnKey_RightColumn, [
            { panelKey: PanelKey_NextSteps, height: 0.5 },
            { panelKey: PanelKey_AddProtocolData, height: 0.5 },
        ]);
    },
    () => {
        ModuleFE_AdvisorBoard.updateColumnsWidth({
            [ColumnKey_LeftColumn]: { width: 0 },
            [ColumnKey_MiddleColumn]: { width: 0.5 },
            [ColumnKey_RightColumn]: { width: 0.5 },
        });
    },
    () => {
        ModuleFE_AdvisorBoard.updateColumnsWidth({
            [ColumnKey_LeftColumn]: { width: 1 },
            [ColumnKey_MiddleColumn]: { width: 0 },
            [ColumnKey_RightColumn]: { width: 0 },
        });
    },
    () => {
        ModuleFE_AdvisorBoard.updateColumnsWidth({
            [ColumnKey_LeftColumn]: { width: 1 / 3 },
            [ColumnKey_MiddleColumn]: { width: 1 / 3 },
            [ColumnKey_RightColumn]: { width: 1 / 3 },
        });
    },
    () => {
        ModuleFE_AdvisorBoard.setColumnItems(ColumnKey_LeftColumn, [
            { panelKey: PanelKey_Inbox, height: 1 / 3 },
            { panelKey: PanelKey_HPI, height: 1 / 3 },
            { panelKey: PanelKey_SmartDocs, height: 1 / 3 },
        ]);
        ModuleFE_AdvisorBoard.setColumnItems(ColumnKey_MiddleColumn, [
            { panelKey: PanelKey_Spotlight, height: 0.5 },
            { panelKey: PanelKey_Findings, height: 0.5 },
        ]);
        ModuleFE_AdvisorBoard.setColumnItems(ColumnKey_RightColumn, [
            { panelKey: PanelKey_NextSteps, height: 0.5 },
            { panelKey: PanelKey_AddProtocolData, height: 0.5 },
        ]);
    },
    () => {
        ModuleFE_AdvisorBoard.updateColumnsWidth({
            [ColumnKey_LeftColumn]: { width: 0.3 },
            [ColumnKey_MiddleColumn]: { width: 0.7 },
            [ColumnKey_RightColumn]: { width: 0 },
        });
        ModuleFE_AdvisorBoard.setColumnItems(ColumnKey_LeftColumn, [
            { panelKey: PanelKey_Inbox, height: 0.4 },
            { panelKey: PanelKey_HPI, height: 0 },
            { panelKey: PanelKey_SmartDocs, height: 0.6 },
        ]);
        ModuleFE_AdvisorBoard.setColumnItems(ColumnKey_MiddleColumn, [
            { panelKey: PanelKey_Spotlight, height: 1 },
            { panelKey: PanelKey_Findings, height: 200 },
        ]);
    },
    () => ModuleFE_AdvisorBoard.resetAdvisorBoard(),
    () => {
        ModuleFE_AdvisorBoard.setColumnItems(ColumnKey_LeftColumn, RightColumnNew_Base);
        ModuleFE_AdvisorBoard.setColumnItems(ColumnKey_MiddleColumn, LeftColumn_AllClosed);
        ModuleFE_AdvisorBoard.setColumnItems(ColumnKey_RightColumn, MiddleColumn_Findings);
    },
    () => {
        ModuleFE_AdvisorBoard.setColumnItems(ColumnKey_LeftColumn, MiddleColumn_Findings);
        ModuleFE_AdvisorBoard.setColumnItems(ColumnKey_MiddleColumn, RightColumnNew_Base);
        ModuleFE_AdvisorBoard.setColumnItems(ColumnKey_RightColumn, LeftColumn_AllClosed);
    },
    () => ModuleFE_AdvisorBoard.resetAdvisorBoard(),
    () => {
        ModuleFE_AdvisorBoard.updateColumnsWidth({
            [ColumnKey_LeftColumn]: { width: 0.5 },
            [ColumnKey_MiddleColumn]: { width: 0.5 },
            [ColumnKey_RightColumn]: { width: 0 },
        });
        ModuleFE_AdvisorBoard.setColumnItems(ColumnKey_LeftColumn, [
            { panelKey: PanelKey_Inbox, height: 0.25 },
            { panelKey: PanelKey_HPI, height: 0.25 },
            { panelKey: PanelKey_SmartDocs, height: 0.25 },
            { panelKey: PanelKey_Findings, height: 0.25 },
            { panelKey: PanelKey_Settings, height: CollapsedPanelHeight },
        ]);
        ModuleFE_AdvisorBoard.setColumnItems(ColumnKey_MiddleColumn, [
            { panelKey: PanelKey_Findings, height: 0.5 },
            { panelKey: PanelKey_NextSteps, height: 0.5 },
        ]);
        ModuleFE_AdvisorBoard.setColumnItems(ColumnKey_RightColumn, []);
    },
    () => {
        ModuleFE_AdvisorBoard.setColumnItems(ColumnKey_LeftColumn, [
            { panelKey: PanelKey_Inbox, height: 0.3 },
            { panelKey: PanelKey_HPI, height: 0.3 },
            { panelKey: PanelKey_SmartDocs, height: 50 },
            { panelKey: PanelKey_Findings, height: 0.4 },
            { panelKey: PanelKey_Settings, height: CollapsedPanelHeight },
        ]);
        ModuleFE_AdvisorBoard.setColumnItems(ColumnKey_MiddleColumn, [
            { panelKey: PanelKey_Findings, height: 0.8 },
            { panelKey: PanelKey_NextSteps, height: 0.2 },
        ]);
    },
    () => {
        ModuleFE_AdvisorBoard.setColumnItems(ColumnKey_LeftColumn, [
            { panelKey: PanelKey_Inbox, height: 0.1 },
            { panelKey: PanelKey_HPI, height: 0.1 },
            { panelKey: PanelKey_SmartDocs, height: 0.5 },
            { panelKey: PanelKey_Findings, height: 0.3 },
            { panelKey: PanelKey_Settings, height: CollapsedPanelHeight },
        ]);
        ModuleFE_AdvisorBoard.setColumnItems(ColumnKey_MiddleColumn, [
            { panelKey: PanelKey_Findings, height: 0.2 },
            { panelKey: PanelKey_NextSteps, height: 0.8 },
        ]);
    },
    () => {
        ModuleFE_AdvisorBoard.setColumnItems(ColumnKey_LeftColumn, [
            { panelKey: PanelKey_Inbox, height: 0.25 },
            { panelKey: PanelKey_HPI, height: 0.25 },
            { panelKey: PanelKey_SmartDocs, height: 0.25 },
            { panelKey: PanelKey_Findings, height: 0.25 },
            { panelKey: PanelKey_Settings, height: CollapsedPanelHeight },
        ]);
        ModuleFE_AdvisorBoard.setColumnItems(ColumnKey_MiddleColumn, [
            { panelKey: PanelKey_Findings, height: 0.5 },
            { panelKey: PanelKey_NextSteps, height: 0.5 },
        ]);
    },
    () => ModuleFE_AdvisorBoard.resetAdvisorBoard(),
];
//# sourceMappingURL=make-it-dance.js.map